import { hasRoleAtLeast, isBhiAdmin } from 'src/helpers/permissions';

type PresetPermissionProfile =
  | { type?: string; role?: { name?: string } | null }
  | null
  | undefined;

// Whether the user may manage campaign presets — create, edit and archive them.
// Allowed for admins, or when the user's role is at least as privileged as
// company_manager.
export function canManagePresets(profile: PresetPermissionProfile): boolean {
  if (isBhiAdmin(profile)) return true;
  return hasRoleAtLeast(profile?.role?.name, 'company_manager');
}
